import { Button } from 'blaze-ui/Button'
import { PropsWithChildren, useCallback } from 'react'
import { FormikErrors } from 'formik/dist/types'
import { useFormikContext } from 'formik'
import { NextButtonProps } from 'components/Wizards/Wizard/Form/Types'

export const NextButton = ({
  onNext,
  fields,
  children,
  variant = 'primary',
  isDisabled,
}: PropsWithChildren<NextButtonProps>) => {
  const { setFieldTouched } = useFormikContext()
  const completeManualSection = useCallback(() => {
    let promise: Promise<void | FormikErrors<any>> = Promise.resolve()

    fields.forEach(([name]) => {
      promise = setFieldTouched(name, true, true)
    })

    promise.then((result) => {
      const errors = result
        ? Object.entries(result).filter(([name]) => fields.map(([name]) => name).includes(name))
        : []
      onNext(Object.fromEntries(errors))
    })
  }, [onNext]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Button onPress={completeManualSection} variant={variant} isDisabled={isDisabled}>
      {children}
    </Button>
  )
}
